import React from "react";
import { Grid, InputAdornment, Typography } from "@mui/material";
import "../../whatsapp interface/WhatsappPreview.css";

import {
  ComponentHeader,
  Paper,
  TextField,
  Label,
} from "../../../../components";

export default function TemplateFooter({ formikProps, addSample }) {
  return (
    <Paper>
      <Grid style={{ alignSelf: "center" }} item xs={12}>
        <ComponentHeader title={"Template Footer"} />

        <Typography
          variant="subtitle2"
          gutterBottom
          style={{ color: "#808080b3" }}
        >
          Add a short line of text to the bottom of your template
          message(Optional).
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Label title="Footer Text" />

        <TextField
          placeholder="Footer Text"
          name="templateFooter.text"
          formikProps={formikProps}
          disabled={
            Boolean(formikProps.values.ID) ||
            Boolean(addSample) ||
            formikProps.isSubmitting
          }
          inputProps={{
            maxLength: 60,
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {formikProps.values?.templateFooter?.text?.length}/60
              </InputAdornment>
            ),
          }}
        />
      </Grid>
    </Paper>
  );
}
